import { React } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = 'black'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: 'black',
        alignItems: 'center',
        fontWeight: 'bold',
        fontSize: 9,
    },
    Contract_Number: {
        width: '25%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'center',
        fontSize: 9
    },
    Shipping_Method: {
        width: '25%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'center',
        fontSize: 9
    },
    Tracking_Number: {
        width: '25%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'center',
        fontSize: 9
    },
    Ship_Date: {
        width: '25%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'center',
        fontSize: 9
    },

});

const Packing_Slip_Contract_Info_Row = ({ invoice }) => {

    return (
        <>
            <View style={styles.row}>
                <Text style={styles.Contract_Number}>{invoice?.contract_number}</Text>
                <Text style={styles.Shipping_Method}>
                    {
                        (invoice.shipping_method === "Other" || invoice.shipping_method === "Freight")
                            ? invoice?.shipping_method_detail
                            : invoice?.shipping_method
                    }
                </Text>

                <Text style={styles.Tracking_Number}>{invoice?.tracking_number}</Text>
                <Text style={styles.Ship_Date}>{invoice?.ship_date}</Text>
            </View>

        </>

    )
};

export default Packing_Slip_Contract_Info_Row;